export default __webpack_public_path__ + "static/media/cloud-download.bd043f7c.svg";